type NameableUser = {
  readonly id: string;
  readonly email?: string;
  readonly firstName?: string;
  readonly lastName?: string;
};

/**
 * What to call a user on screen. Email is the fallback because a user exists before the profile
 * flow fills in a name, and the id is the last resort so the label is never empty -- an empty
 * label on a table cell means an unclickable link.
 */
export function userDisplayName(user: NameableUser): string {
  const name = [user.firstName, user.lastName].filter(part => part).join(' ');
  return name || user.email || user.id;
}
